import { Provider as JotaiProvider } from 'jotai';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import RootLayout from './layout';
import App from './App';
export default function AppRoot() {
    return (<JotaiProvider>
      <QueryClientProvider client={queryClient}>
        <RootLayout>
          <App />
        </RootLayout>
      </QueryClientProvider>
    </JotaiProvider>);
}
